import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { HiOutlineEmojiHappy } from "react-icons/hi";
import Picker from "emoji-picker-react";

import { participantInfo } from "./utils";
import {
  successGetChat,
  postMessage,
  setHoldPulling,
} from "../../Store/actions/index";
import { IoMdSend } from "react-icons/io";
import { IoCloseCircle } from "react-icons/io5";
import { ImAttachment } from "react-icons/im";
import classes from "./SendMessage.module.css";

const SendMessage = ({ particpatntArr, userId, chatId, chat }) => {
  const dispatch = useDispatch();

  const [message, setMessage] = useState("");

  const { participantId } = participantInfo(particpatntArr, userId);

  const [attachment, setAttachment] = useState(null);

  const [showPicker, setShowPicke] = useState(false);

  const onEmojiClick = (event, emojiObject) => {
    setShowPicke(false);
    setMessage((prevMessage) => prevMessage + emojiObject.emoji);
  };

  const attachmentHandler = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    const ImgTypes = ["image/jpeg", "image/png", "image/gif"];
    const validType = ImgTypes.some((type) => {
      if (file) {
        return file.type === type;
      } else return null;
    });
    if (validType) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        setAttachment(reader.result);
        if (file.size < 10 * Math.pow(10, 6)) {
          setAttachment(reader.result);
        } else {
          setAttachment(null);
        }
      };
    }
  };

  const formSubmitHandler = (event) => {
    event.preventDefault();

    if (!(message.trim() === "")) {
      dispatch(postMessage(message, participantId, chatId, attachment));
      CreatedMessageHandler(message, attachment);
    }

    setMessage("");
    setAttachment(null);
  };

  const CreatedMessageHandler = (message, media) => {
    const updatedChats = { ...chat },
      updatedChatMessages = [...updatedChats.chat_messages],
      newCreatedMessage = {
        id: "HN" + `${new Date().getTime()}`,
        message: message,
        created_at: new Date().toDateString(),
        receiver_id: participantId,
        lightRight: true,
        media: media,
      };

    updatedChatMessages.push(newCreatedMessage);

    updatedChats.chat_messages = updatedChatMessages;

    dispatch(setHoldPulling(false));
    dispatch(successGetChat({ data: updatedChats, pagination_info: null }));
    dispatch(setHoldPulling(true));
  };

  const onChangeHandler = (event) => {
    setMessage(event.target.value);
  };

  return (
    <>
      <form
        className={classes.SendMessage}
        onSubmit={(event) => formSubmitHandler(event)}
        onClick={(e) => {
          if (showPicker) setShowPicke(false);
        }}
      >
        <textarea
          autoFocus={true}
          rows="1"
          placeholder="Enter your message here"
          value={message}
          onChange={(event) => onChangeHandler(event)}
        />
        <button>
          <IoMdSend />
        </button>
        <input
          style={{ display: "none" }}
          type="file"
          id="attachment"
          onChange={(event) => attachmentHandler(event)}
        />
        <label className="bg-white" htmlFor="attachment">
          <ImAttachment />
        </label>
        <small className="bg-white" onClick={() => setShowPicke(!showPicker)}>
          <HiOutlineEmojiHappy />
        </small>
        {attachment && <img src={attachment} alt="attachment" />}
      </form>
      {showPicker && (
        <div className={classes.emoji}>
          <small
            onClick={() => setShowPicke(false)}
            className="d-inline-block bg-white w-100"
            style={{
              position: "relative",
              top: "4px",
              borderTopRightRadius: "4px",
              borderTopLeftRadius: "4px",
              padding: ".2rem 0",
              cursor: "pointer",
            }}
          >
            <IoCloseCircle />
            Close
          </small>
          <Picker onEmojiClick={onEmojiClick} disableAutoFocus={true} native />
        </div>
      )}
    </>
  );
};

export default SendMessage;
